import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "REST & GraphQL APIs", desc: "Structured interfaces for products, integrations, and internal services." },
  { title: "Authentication", desc: "Session, token, and permission models designed for both security and operational clarity." },
  { title: "Webhook Systems", desc: "Reliable event-driven architecture for external services, internal triggers, and workflow automation." },
  { title: "Documentation", desc: "Developer-facing docs that make integrations faster and maintenance less painful." },
  { title: "Performance & Monitoring", desc: "Observability, error handling, and throughput thinking from the start." },
  { title: "Integration Readiness", desc: "API layers that support CRM, ERP, mobile, web, payments, and partner systems cleanly." },
];

const ApiDevelopment = () => (
  <StitchFeaturePage
    label="BACKEND & API DEVELOPMENT"
    title="Backend services"
    titleAccent="built cleanly."
    subtitle="APIs and backend systems that support products, integrations, automation, and scale."
    features={features}
    ctaLabel="DISCUSS YOUR API ARCHITECTURE"
  />
);

export default ApiDevelopment;
